import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import styles from './index.module.scss'

function InformationModal({ showModal, hidemodal, title, onSubmit }) {
    return (
        <Modal
            closeButton
            show={showModal}
            onHide={hidemodal}
            className={styles.information_modal_align}
            backdrop="static"

        >
            <Modal.Body>
                <div className={styles.modalContent}>

                    {/* <div className={styles.closeBar} onClick={hidemodal}>
                        <SimpleCloseIcon />
                    </div> */}
                    <div className={styles.title}>{title}</div>


                  


                </div>
            </Modal.Body>
            <Button
                className={styles.patient_consent_accept_button}
                onClick={onSubmit}
            >
                CLOSE
            </Button>

        </Modal>
    )
}

export default InformationModal